import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Ubah Setting Invoice Product"),
      /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Manajemen data setting invoice")
    ])
  ])
], -1)
const _hoisted_4 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row mb-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 fv-row" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Informasi Invoice")
], -1)
const _hoisted_8 = { class: "col-lg-6 fv-row" }
const _hoisted_9 = { class: "row px-3" }
const _hoisted_10 = { class: "col-12 fv-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Pilih Sekolah", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Sekolah", -1)
const _hoisted_13 = ["label", "value"]
const _hoisted_14 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "col-12 fv-row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Produk", -1)
const _hoisted_18 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "col-12 fv-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Pilih Produk", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Produk", -1)
const _hoisted_23 = ["label", "value"]
const _hoisted_24 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "col-12 fv-row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Default Price", -1)
const _hoisted_28 = { class: "col-lg-6 fv-row" }
const _hoisted_29 = { class: "row px-3" }
const _hoisted_30 = { class: "col-12 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Batas Waktu", -1)
const _hoisted_32 = { class: "col-12 fv-row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Pajak", -1)
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = { class: "col-lg-12 fv-row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h4", null, "Custom Price", -1)
const _hoisted_37 = {
  key: 0,
  class: "row px-3"
}
const _hoisted_38 = { class: "col-lg-12 mt-5" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Price", -1)
const _hoisted_40 = { class: "row px-3" }
const _hoisted_41 = {
  key: 0,
  class: "col-lg-6 mt-5"
}
const _hoisted_42 = { class: "row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Data Diskon Kosong")
], -1)
const _hoisted_44 = {
  class: "col-6",
  style: {"text-align":"end"}
}
const _hoisted_45 = {
  key: 1,
  class: "col-lg-12 mt-5"
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-lg-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Nama Diskon", -1)
const _hoisted_49 = { class: "col-lg-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Batas Waktu Diskon", -1)
const _hoisted_51 = { class: "col-lg-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Diskon", -1)
const _hoisted_53 = {
  class: "col-lg-2 pb-2 pt-2",
  style: {"align-self":"end"}
}
const _hoisted_54 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_custom_price",
  ref: "uploadModalRef"
}
const _hoisted_59 = { class: "modal-dialog" }
const _hoisted_60 = { class: "modal-content" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Data Custom Price"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_62 = { class: "modal-body" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-lg-12" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Harga", -1)
const _hoisted_66 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = { class: "col-lg-12" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Nama Diskon", -1)
const _hoisted_70 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_71 = { class: "fv-help-block" }
const _hoisted_72 = { class: "col-lg-12" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Batas Waktu Diskon", -1)
const _hoisted_74 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_75 = { class: "fv-help-block" }
const _hoisted_76 = { class: "col-lg-12" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Diskon", -1)
const _hoisted_78 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_79 = { class: "fv-help-block" }
const _hoisted_80 = { class: "modal-footer" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "schoolId",
                    disabled: "",
                    modelValue: _ctx.editSetting.schoolId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editSetting.schoolId) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listSchool, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option._id,
                          label: option.name,
                          value: option._id
                        }, null, 8, _hoisted_13))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.editSetting.schoolId == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.errorsMessage.errorschoolId), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "title",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama Produk",
                    modelValue: _ctx.editSetting.title,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editSetting.title) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editSetting.title == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.errorsMessage.errortitle), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "item",
                    modelValue: _ctx.editSetting.item,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editSetting.item) = $event)),
                    disabled: "",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (this.changeProduct()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listProduct, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.id,
                          label: option.name,
                          value: option.id
                        }, null, 8, _hoisted_23))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.editSetting.item == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.errorsMessage.erroritem), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(_component_Field, {
                    disabled: "",
                    type: "number",
                    name: "defaultPrice",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Default Price",
                    modelValue: _ctx.editSetting.defaultPrice,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editSetting.defaultPrice) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_Field, {
                    type: "number",
                    name: "expiredInDays",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Batas Waktu (dalam hari)",
                    modelValue: _ctx.editSetting.expiredInDays,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editSetting.expiredInDays) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode(_component_Field, {
                    type: "number",
                    name: "tax",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Pajak (Dalam Percent %)",
                    modelValue: _ctx.editSetting.tax,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editSetting.tax) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              (_ctx.editSetting.statusCustomPrice == 'ready' && _ctx.customPrice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "namaDiskon",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Nama Diskon",
                        disabled: "",
                        modelValue: _ctx.customPrice.price,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.customPrice.price) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_40, [
                (_ctx.editSetting.statusCustomPrice != 'ready')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("button", {
                            class: "btn btn-success me-3",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#kt_modal_custom_price",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openaddmodal()))
                          }, " Tambah ")
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editSetting.statusCustomPrice == 'ready')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "namaDiskon",
                            class: "form-control form-control-lg",
                            placeholder: "Isi Nama Diskon",
                            disabled: "",
                            modelValue: _ctx.discount.title,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.discount.title) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _createVNode(_component_Field, {
                            type: "date",
                            name: "expiredDateDiskon",
                            class: "form-control form-control-lg",
                            placeholder: "Isi Tanggal Selesai",
                            disabled: "",
                            modelValue: _ctx.discount.dueDate,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.discount.dueDate) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "banyakDiskon",
                            class: "form-control form-control-lg",
                            placeholder: "Isi Banyak Diskon (Dalam Percent %)",
                            modelValue: _ctx.discount.discount,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.discount.discount) = $event)),
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("button", {
                            class: "btn btn-warning me-3",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#kt_modal_custom_price",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openeditmodal()))
                          }, " Ubah ")
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("button", {
            class: "btn btn-danger me-3",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push('/superadmin/setting-invoices-product')))
          }, " Batal "),
          _createElementVNode("button", {
            type: "submit",
            id: "kt_account_profile_details_submit",
            ref: "submitButton",
            class: "btn btn-primary",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.saveChanges1()))
          }, _hoisted_57, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createVNode(_component_Field, {
                    type: "number",
                    name: "customPrice",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama Diskon",
                    modelValue: _ctx.customPrice.price,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.customPrice.price) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.customPrice.price == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.errorsMessage.errorcustomprice), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "namaDiskon",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama Diskon",
                    modelValue: _ctx.discount.title,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.discount.title) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.discount.title == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.errorsMessage.errornamadiskon), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _createVNode(_component_Field, {
                    type: "date",
                    name: "expiredDateDiskon",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Tanggal Selesai",
                    modelValue: _ctx.discount.dueDate,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.discount.dueDate) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.discount.dueDate == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.errorsMessage.errortanggaldiskon), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createVNode(_component_Field, {
                    type: "number",
                    name: "banyakDiskon",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Banyak Diskon (Dalam Percent %)",
                    modelValue: _ctx.discount.discount,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.discount.discount) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.discount.discount == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.errorsMessage.errorbanyakdiskon), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _hoisted_81,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.saveModal()))
              }, " Simpan ")
            ])
          ])
        ])
      ], 512)
    ])
  ], 64))
}